import { Component, OnInit } from '@angular/core';
import { ConfigurationService, RuntimeConfigService } from '../_shared/services/services-index';
import { AppState } from '../_store/app-state.model';
import { Store } from '@ngrx/store';
import { environment } from '../../environments/environment';

@Component({
    templateUrl: './logout.component.html',
    styleUrls: ['./logout.component.scss'],
    standalone: false
})

export class LogoutComponent implements OnInit {

  content: string[] = [];

  constructor(
    private configService: ConfigurationService,
    private runtimeConfigService: RuntimeConfigService) {
  }

  ngOnInit() {
    const logoutRoute = this.runtimeConfigService.routingConfig.find(r => r.id === 'logout');

    if (!!logoutRoute?.routeData?.redirectOnLogout) {
      window.location.href = environment.logoutRedirectUrl;
    }
    else {
      this.content = logoutRoute?.routeData?.content || ['You have been successfully logged out.'];
    }
  }
}
